
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PageWrapper } from "@/components/layout/PageWrapper";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Log 404 error for monitoring (could be sent to analytics service)
    // console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <PageWrapper layout="no-sidebar">
      <div className="min-h-screen flex items-center justify-center bg-gray-100 font-sans">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4 font-urbanist">404</h1>
          <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
          <a href="/" className="text-blue-500 hover:text-blue-700 underline">
            Return to Home
          </a>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NotFound;
